import { lazy } from "react";
import Loadable from "../../../../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../../../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../../../../constants/enums";
import { HABITATIONAL_POLICY_FORM_CANCELLATION_REINSTATEMENT } from "./Habitational.constants";

const HabitationalCancellation = Loadable(
  lazy(() =>
    import("./HabitationalCancellation/HabitationalCancellation").then(
      ({ HabitationalCancellation }) => ({
        default: HabitationalCancellation,
      })
    )
  )
);

const HabitationalPolicyIntactAuthorization = Loadable(
  lazy(() =>
    import(
      "./HabitationalPolicyIntactAuthorization/HabitationalPolicyIntactAutorization"
    ).then(({ HabitationalPolicyIntactAuthorization }) => ({
      default: HabitationalPolicyIntactAuthorization,
    }))
  )
);
const HabitationalLossNotice = Loadable(
  lazy(() =>
    import("./HabitationalPolicyForms/HabitationalLossNotice").then(
      ({ HabitationalLossNotice }) => ({
        default: HabitationalLossNotice,
      })
    )
  )
);

export const HabitationalPolicyFormsRoutes = [
  {
    path: `${HABITATIONAL_POLICY_FORM_CANCELLATION_REINSTATEMENT}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
        <HabitationalCancellation />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${HABITATIONAL_POLICY_FORM_CANCELLATION_REINSTATEMENT}/:serialNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
        <HabitationalCancellation />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${HABITATIONAL_POLICY_FORM_CANCELLATION_REINSTATEMENT}/duplicate/:serialNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
        <HabitationalCancellation isDuplicate />
      </AuthorizedRoute>
    ),
  },

  {
    path: `/habitational-policy/:customerId/policy-forms-tab/:customerPolicyId/intact-authorization`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
        <HabitationalPolicyIntactAuthorization />
      </AuthorizedRoute>
    ),
  },
  {
    path: `/habitational-policy/:customerId/policy-forms-tab/:customerPolicyId/intact-authorization/:serialNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
        <HabitationalPolicyIntactAuthorization />
      </AuthorizedRoute>
    ),
  },
  {
    path: `/habitational-policy/:customerId/policy-forms-tab/:customerPolicyId/intact-authorization/duplicate/:serialNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
        <HabitationalPolicyIntactAuthorization isDuplicate />
      </AuthorizedRoute>
    ),
  },
  {
    path: `/habitational-policy/:customerId/policy-forms-tab/:customerPolicyId/loss-notice`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
        <HabitationalLossNotice />
      </AuthorizedRoute>
    ),
  },
  {
    path: `/habitational-policy/:customerId/policy-forms-tab/:customerPolicyId/loss-notice/:claimNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
        <HabitationalLossNotice />
      </AuthorizedRoute>
    ),
  },
  {
    path: `/habitational-policy/:customerId/policy-forms-tab/:customerPolicyId/loss-notice/duplicate/:claimNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
        <HabitationalLossNotice isDuplicate />
      </AuthorizedRoute>
    ),
  },
];
